import { getCookie, deleteCookie } from './cookie';

export const getToken = () => {
	const tokenDefault = {
		accessToken: '',
		endAt: '',
		expiresIn: '',
		refreshToken: '',
	};

	return JSON.parse(getCookie('olympus-token')) || tokenDefault;
};

export const removeToken = () => {
	deleteCookie('olympus-token');
};
